export default "__VITE_ASSET__DaemH5G$__"